import Status from './status';

export default ({active, onClick, bonus}) => (
    <div className={`method-20 ${!active ? 'not-available' : ''}`} onClick={e => {
        // toast.dismiss();
        // toast.info('Debit cards under maintenance now. Use Chime or Crypto to make deposits.');

        if(!active)
            return;

        onClick({
            mode: "methods",
            method: "cards-deposit"
        });
    }}>
        <div className="info">
            <div className="icon multiple">
                <div className="i mc">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.25 14.25C8.14949 14.25 10.5 11.8995 10.5 9C10.5 6.1005 8.14949 3.75 5.25 3.75C2.3505 3.75 0 6.1005 0 9C0 11.8995 2.3505 14.25 5.25 14.25Z" fill="#EA001B"/>
                        <path d="M12.75 14.25C15.6495 14.25 18 11.8995 18 9C18 6.1005 15.6495 3.75 12.75 3.75C9.8505 3.75 7.5 6.1005 7.5 9C7.5 11.8995 9.8505 14.25 12.75 14.25Z" fill="#FFA200" fill-opacity="0.8"/>
                    </svg>
                </div>

                <div className="i visa">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3994_1622)">
                            <path d="M22.222 15.7681L21.997 14.6431H19.483L19.083 15.7601L17.068 15.7641C18.0273 13.4573 18.9886 11.1513 19.952 8.84612C20.116 8.45512 20.407 8.25612 20.836 8.25812C21.164 8.26112 21.699 8.26112 22.442 8.25912L24 15.7651L22.222 15.7681ZM20.049 13.1021H21.669L21.064 10.2821L20.049 13.1021ZM7.06 8.25712L9.086 8.25912L5.954 15.7691L3.903 15.7671C3.38725 13.7834 2.87791 11.7981 2.375 9.81112C2.275 9.41512 2.077 9.13812 1.696 9.00712C1.357 8.89012 0.792 8.71012 0 8.46512V8.26012H3.237C3.797 8.26012 4.124 8.53112 4.229 9.08712C4.335 9.64412 4.601 11.0621 5.029 13.3411L7.06 8.25712ZM11.87 8.25912L10.268 15.7671L8.34 15.7651L9.94 8.25712L11.87 8.25912ZM15.78 8.12012C16.357 8.12012 17.084 8.30012 17.502 8.46512L17.164 10.0221C16.786 9.87012 16.164 9.66512 15.641 9.67212C14.881 9.68512 14.411 10.0041 14.411 10.3101C14.411 10.8081 15.227 11.0591 16.067 11.6031C17.026 12.2231 17.152 12.7801 17.14 13.3851C17.127 14.6411 16.067 15.8801 13.831 15.8801C12.811 15.8651 12.443 15.7791 11.611 15.4841L11.963 13.8591C12.81 14.2141 13.169 14.3271 13.893 14.3271C14.556 14.3271 15.125 14.0591 15.13 13.5921C15.134 13.2601 14.93 13.0951 14.186 12.6851C13.442 12.2741 12.398 11.7051 12.412 10.5631C12.429 9.10112 13.814 8.12012 15.781 8.12012H15.78Z" fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_3994_1622">
                                <rect width="24" height="24" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>


                {/* <img src={`${window.location.origin}/source/system/wallet/visamc.png`} alt="Icon" /> */}
            </div>

            <Status available={active} bonus={0} deposit_bonus={bonus} fee={10} />
        </div>

        <div className="name">Debit Card</div>
    </div>
)